import _ from "lodash";
import * as z from "../../framework";
import { codes } from "../data/codes";
import * as filter from "../data/filter";
import { clone } from "./core";
import { ll } from "./ll";
import { user } from "./user";
import { isFunction } from "./util";
import { makeAPIClient } from "../../framework/util";
import { AxiosRequestConfig } from "axios";
function divisionAndRegionEnabled() {
    return (
        user && user.companyData && user.companyData.DivisionAndRegionEnabled
    );
}

export function createDivisionAndRegionSearchOptions(options) {
    options = options || {};

    options.divisionsNavigationTypes = options.divisionsNavigationTypes || "";
    options.regionsNavigationTypes = options.regionsNavigationTypes || "";

    var divisionsDataSource = createDivisionsDatasource(options);

    var regionsNavigationTypes = "Region/";

    if (options.regionsNavigationTypes) {
        regionsNavigationTypes = `${options.regionsNavigationTypes}Region/`;
    }

    var additionalFilter = `EmployeeRegion/UserId eq ${user.loginData.UserId}`;

    if (options.regionNotRequired) {
        additionalFilter = `(${additionalFilter} or ShipToId eq null)`;
    }

    var divAndRegOptions: any = {
        division: {
            field: `${options.divisionsNavigationTypes.replaceAll(
                "/",
                "."
            )}Division`,
            type: "ComboBox",
            label: "Division",
            dataSource: divisionsDataSource.dataSource,
            defaultValue:
                options.divisionDefaultValue ||
                divisionsDataSource.defaultValue,
            entityType: "Division"
        },
        region: {
            field: `${regionsNavigationTypes.replaceAll("/", ".")}RegionNumber`,
            type: "AutoComplete",
            label: {
                type: "ll",
                value: "Entity.Region"
            },
            searchType: "Region",
            searchOptions: [
                {
                    field: "RegionNumber",
                    type: "AutoComplete",
                    searchType: "Region",
                    setAdditionalAutoCompleteFilter: additionalFilter
                },
                {
                    field: "RegionName",
                    type: "AutoComplete",
                    searchType: "Region",
                    setAdditionalAutoCompleteFilter: additionalFilter
                }
            ],
            autoCompleteConditional: [
                { value: "RegionNumber" },
                { value: "RegionName" }
            ],
            setAdditionalAutoCompleteFilter: additionalFilter,
            defaultDisplayValue: ""
        }
    };
    if (options.divisions) {
        if (
            isFunction(options.defaultDivisionSearchOption) &&
            options.defaultDivisionSearchOption() !== false
        ) {
            var divisionsDefault = options.defaultDivisionSearchOption();
            if (divisionsDefault == null) {
                divAndRegOptions.division.defaultValue = -3;
            } else {
                divAndRegOptions.division.defaultValue = divisionsDefault;
            }
        }
    }

    if (options.regions) {
        var regionsDefault;
        if (
            isFunction(options.defaultRegionSearchOption) &&
            options.defaultRegionSearchOption() !== false
        ) {
            regionsDefault = options.defaultRegionSearchOption();
            divAndRegOptions.region.defaultValue = regionsDefault;
            divAndRegOptions.region.defaultDisplayValue = regionsDefault;
        }

        if (options.regionNotRequired == true) {
            divAndRegOptions.region.setAdditionalAutoCompleteFilter = `EmployeeRegion/UserId eq ${user.loginData.UserId}`;
        }
    }

    return divAndRegOptions;
}

export function createDivisionsFilterStrings(divisionId, filterPrefix) {
    var filt = "";
    if (!filterPrefix) {
        filterPrefix = "";
    }

    if (divisionId > 0) {
        filt = `${filterPrefix}DivisionId eq ${divisionId}`;
    }

    if (divisionId == -2 && user.myDivision.Id) {
        filt = `(${filterPrefix}DivisionId eq null OR ${filterPrefix}DivisionId eq ${user.myDivision.Id})`;
    }

    if (divisionId == -3) {
        filt = `${filterPrefix}DivisionId eq null`;
    }

    return filt;
}

export function getDivisionsFilterIds(divisionId) {
    if (divisionId > 0) {
        return [divisionId];
    }

    if (divisionId == -2 && user.myDivision.Id) {
        return [null, user.myDivision.Id];
    }

    if (divisionId == -3) {
        return [null];
    }

    return [];
}

export function createDivisionAndRegionSearchOptionsForAll() {
    var args = {
        divisionsNavigationTypes: "",
        regionsNavigationTypes: "Default"
    };

    var divisionRegionOptions = createDivisionAndRegionSearchOptions(args);

    divisionRegionOptions.division.defaultValue = "-1";
    divisionRegionOptions.region.setAdditionalAutoCompleteFilter = `EmployeeRegion/UserId eq ${user.loginData.UserId}`;

    var arrSearchOptions = [];
    arrSearchOptions.push(divisionRegionOptions.division);
    arrSearchOptions.push(divisionRegionOptions.region);

    return arrSearchOptions;
}

export function createDivisionsDatasource(options?) {
    options = options || {};
    var dDataSource = [];
    var myDivision = user.myDivision;
    var all = options.all === undefined ? true : options.all;

    options = options || {};

    options.divisionsNavigationTypes = options.divisionsNavigationTypes || "";

    if (all) {
        dDataSource.push({
            DivisionNumber: ll("All"),
            DivisionName: ll("AllDivisions"),
            SortOrder: -2,
            Id: -1,
            odata: {} // Need an empty odata filter otherwise comboboxes get cleared because
            // the value is -1 just like this Id
        });
    }

    dDataSource.push({
        DivisionNumber: ll("Global"),
        DivisionName: ll("GlobalDivision"),
        SortOrder: 0,
        Id: -3,
        odata: filter.all(
            filter.equals(
                `${options.divisionsNavigationTypes}DivisionId`,
                "null"
            )
        ).kendoFilter
    });

    var defaultValue = -1;

    if (myDivision && myDivision.Id && divisionAndRegionEnabled()) {
        var myDivisionSearch = {
            DivisionNumber: `${ll("GlobalPlus")}${myDivision.DivisionNumber}`,
            DivisionName: `${ll("GlobalPlusName")}${myDivision.DivisionName}`,
            Id: -2,
            SortOrder: -1,
            odata: filter.any(
                filter.any(
                    filter.equals(
                        `${options.divisionsNavigationTypes}DivisionId`,
                        "null"
                    ),
                    filter.equals(
                        `${options.divisionsNavigationTypes}DivisionId`,
                        myDivision.Id
                    )
                )
            ).kendoFilter
        };

        if (options.divisionsAndRegionsAndMyStuff) {
            myDivisionSearch.DivisionNumber += ll("AndAssignedToMe");
            myDivisionSearch.DivisionName += ll("AndItemsAssignedToMe");
            myDivisionSearch.odata.filters.push(
                filter.equals(
                    `${options.divisionsNavigationTypes}AssignedToId`,
                    user.loginData.UserId
                ).kendoFilter
            );
        }

        dDataSource.push(myDivisionSearch);

        defaultValue = -2;
    }

    $.each(codes.Division, function (index, division) {
        if (division.Id) {
            var clonedDivision = clone(division);

            clonedDivision.odata = filter.all(
                filter.equals(
                    `${options.divisionsNavigationTypes}DivisionId`,
                    division.Id
                )
            ).kendoFilter;

            dDataSource.push(clonedDivision);
        }
    });

    return {
        dataSource: dDataSource,
        defaultValue: defaultValue
    };
}

export function defaultRegionIsGlobalRegion() {
    let defaultRegionId = z.user.companyData.EmployeeDefaultRegionId;
    let defaultRegion = _.find(z.codes.Region, { Id: defaultRegionId } as {});

    const isGlobal =
        defaultRegion &&
        defaultRegion.RegionNumber &&
        defaultRegion.RegionNumber.toUpperCase() == "GLOBAL";

    return isGlobal;
}

export function getRegionSearchOptionFilter(options) {
    options = options || {};
    options.searchType = options.searchType || {};

    var regions =
        options.regions === undefined
            ? options.searchType.regions
            : options.regions;

    if (!regions || !divisionAndRegionEnabled()) {
        return undefined;
    }

    var regionNavigationTypes =
        options.regionsNavigationTypes ||
        options.searchType.regionsNavigationTypes ||
        "";
    var filt;
    var overrideFilter;

    if (
        options.regionsFilterOverride &&
        isFunction(options.regionsFilterOverride)
    ) {
        overrideFilter = options.regionsFilterOverride();
    }

    const defaultIsGlobal = defaultRegionIsGlobalRegion();

    if (!overrideFilter) {
        if (options.searchType.regionNotRequired) {
            filt = filter.any(
                filter.equals("ShipTo", null),
                filter.equals(
                    `${regionNavigationTypes}Region/EmployeeRegion/UserId`,
                    user.loginData.UserId
                )
            );
        } else if (!defaultIsGlobal) {
            filt = filter.equals(
                `${regionNavigationTypes}Region/EmployeeRegion/UserId`,
                user.loginData.UserId
            );
        }

        if (
            !defaultIsGlobal &&
            (options.searchType.divisionsAndRegionsAndMyStuff ||
                options.divisionsAndRegionsAndMyStuff)
        ) {
            let newFilter = filter.equals(
                `${regionNavigationTypes}AssignedToId`,
                user.loginData.UserId
            );
            if (filt) {
                filt = filter.any(filt, newFilter);
            } else {
                filt = newFilter;
            }
        }
    } else if (overrideFilter !== true) {
        filt = overrideFilter;
    }

    var regionFilter = filt ? filt.kendoFilter : {};

    return {
        regionFilter: regionFilter,
        allSpaces: !regionFilter
    };
}

export function createAutocompleteFilterExpression(options, searchType) {
    options = options || {};
    searchType = searchType || {};

    var divisions =
        options.divisions === undefined
            ? searchType.divisions
            : options.divisions;

    var regions =
        options.regions === undefined ? searchType.regions : options.regions;

    var divisionsNavigationTypes =
        options.divisionsNavigationTypes ||
        searchType.divisionsNavigationTypes ||
        "";
    var regionsNavigationTypes =
        options.regionsNavigationTypes ||
        searchType.regionsNavigationTypes ||
        "";

    var originalFilter = options.filterExpression;

    if (!((divisions || regions) && divisionAndRegionEnabled())) {
        return undefined;
    }

    return function () {
        var originalFilterString = originalFilter || "";
        var divisionsFilter = filter.empty();
        var regionsFilter = filter.empty();
        var divisionsFilterOverride;
        var regionsFilterOverride;
        var filterArray = [];

        var regionNotRequired =
            options.regionNotRequired === undefined
                ? searchType.regionNotRequired
                : options.regionNotRequired;

        if (isFunction(originalFilter)) {
            originalFilterString = originalFilter() || "";
        }

        if (isFunction(options.divisionsFilterOverride)) {
            divisionsFilterOverride = options.divisionsFilterOverride();
        }

        if (isFunction(options.regionsFilterOverride)) {
            regionsFilterOverride = options.regionsFilterOverride();
        }

        if (divisions && user.myDivision && user.myDivision.Id) {
            if (divisionsFilterOverride === true) {
                // If divisions filter override is true we dont want to add a divisions filter
            } else if (
                divisionsFilterOverride === false ||
                divisionsFilterOverride === undefined ||
                divisionsFilterOverride === null
            ) {
                divisionsFilter = divisionsFilter.andAny(
                    filter
                        .equals(`${divisionsNavigationTypes}DivisionId`, null)
                        .orEquals(
                            `${divisionsNavigationTypes}DivisionId`,
                            user.myDivision.Id
                        )
                );
            } else {
                divisionsFilter = divisionsFilter.andAll(
                    divisionsFilterOverride
                );
            }
        }

        if (regions) {
            if (regionsFilterOverride === true) {
                // If regions filter override is true we dont want to add a regions filter
            } else if (
                regionsFilterOverride === false ||
                regionsFilterOverride === undefined ||
                regionsFilterOverride === null
            ) {
                regionsFilter = regionsFilter.andEquals(
                    `${regionsNavigationTypes}Region/EmployeeRegion/UserId`,
                    user.loginData.UserId
                );
            } else {
                regionsFilter = regionsFilter.andAll(regionsFilterOverride);
            }

            // If region not required means that we want to do the "or ShipToId eq null"
            if (regionsFilterOverride !== true && regionNotRequired) {
                regionsFilter = regionsFilter.orIsNull("ShipToId");
            }
        }

        var divisionAndRegionFilter = filter.all(
            divisionsFilter,
            regionsFilter
        );

        if (divisionAndRegionFilter.toString()) {
            filterArray.push(divisionAndRegionFilter);
        }

        if (options.divisionsAndRegionsAndMyStuff) {
            filterArray.push(
                filter.equals("AssignedToId", user.loginData.UserId)
            );
        }

        var filterString = filter.any(filterArray).toString();

        if (!filterString) {
            return originalFilterString;
        }

        if (originalFilterString) {
            return filter.all(originalFilterString, filterString).toString();
        }

        return filterString;
    };
}

const localStorageKey = "myAccessibleRegionIds";
function getCachedAccessibleRegions(): number[] {
    const regionIds = JSON.parse(
        z.util.getLocalStorage(localStorageKey) || "[]"
    );
    if (regionIds && !_.isEmpty(regionIds)) {
        return regionIds;
    }
    return null;
}
function cacheMyAccessibleRegions(regionIds: number[]) {
    z.util.setLocalStorage(localStorageKey, JSON.stringify(regionIds));
}
async function fetchMyAccessibleRegions(): Promise<number[]> {
    const userId = z.user.loginData.UserId;
    const regionsEndpoint = "Region";
    const regionsFilter = z.filter
        .empty()
        .andEquals("EmployeeRegion/UserId", userId)
        .toString();
    const apiClient = makeAPIClient({
        serviceProApiUrl: window.z.configuration.serviceProApiUrl || ""
    });
    const config: AxiosRequestConfig = {
        method: "GET",
        url: regionsEndpoint,
        params: { $filter: regionsFilter, $select: "Id" }
    };
    const regionIdsPromise = apiClient.request(config);

    return regionIdsPromise.then(response =>
        response.data.d.results.map(r => r.Id)
    );
}

export async function getMyAccessibleRegions(): Promise<number[]> {
    const cachedRegions = getCachedAccessibleRegions();
    if (cachedRegions) {
        return Promise.resolve(cachedRegions);
    } else {
        const fetchedRegions = await fetchMyAccessibleRegions();
        cacheMyAccessibleRegions(fetchedRegions);
        return fetchedRegions;
    }
}
